import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectKeyPipe'
})
export class ObjectKeyPipe implements PipeTransform {

  // 
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/_pipes/object-key.pipe.ts